
import {CORE_CONCEPTS} from './data.js'
import Header from './components/Header/Header.jsx'
import CoreConcept from './components/CoreConcept.jsx';
import TabButton from './components/TabButton.jsx'
import { useState } from 'react';
import {EXAMPLES} from './data.js'

function App() {

  const [selectedTopic, setSelectedTopic] = useState()

  // let tabContent = "Please select aaa a button";

  function handleSelect(selectedButton){
    // slectedButton = 'components','JSX','props','state'
    setSelectedTopic(selectedButton)      // updating the value on UI

    // tabContent = selectButton;
    
    // console.log(tabContent);
  }


  return (
    <div>
      <Header />

      <main>
        <h2>Time to get started!!!</h2>
        <section id="core-concepts">
            <h2>Core Concepts</h2>
            <ul> 
              {CORE_CONCEPTS.map((conceptItem) => (
                <CoreConcept key={conceptItem.title} {...conceptItem}/>
              ))}
              {/* <CoreConcept {...CORE_CONCEPTS[0]}/> 
              <CoreConcept {...CORE_CONCEPTS[1]}/>
              <CoreConcept {...CORE_CONCEPTS[2]}/> 
              <CoreConcept {...CORE_CONCEPTS[3]}/> */}
            </ul>
      </section>
      <section id="examples">
        <h2>Examples</h2>
        <menu>
          <TabButton isSelected = {selectedTopic === "components"} onSelect={() => handleSelect("components")}>Components</TabButton>
          <TabButton isSelected = {selectedTopic === "jsx"} onSelect={() => handleSelect("jsx")}>JSX</TabButton>
          <TabButton isSelected = {selectedTopic === "props"} onSelect={() => handleSelect("props")}>Props</TabButton>
          <TabButton isSelected = {selectedTopic === "state"} onSelect={() => handleSelect("state")}>State</TabButton>
        </menu>

        {!selectedTopic ? (<p>Please select a tab</p>) : 
        (<div id='tab-content'>
          <h3>{EXAMPLES[selectedTopic].title}</h3>
          <p>{EXAMPLES[selectedTopic].description}</p>
          <pre><code>{EXAMPLES[selectedTopic].code}</code></pre>
        </div>)}
      </section>
      </main>
    </div>
  );
}

export default App;
